import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl text-primary-700 font-bold" }, "Change Password", -1)
const _hoisted_2 = { class: "bg-white rounded-lg px-5 py-9 w-full" }
const _hoisted_3 = { class: "md:w-1/2" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = { class: "mb-6" }

import PortalLayout from '@/layouts/PortalLayout.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import PasswordInput from '@/components/inputs/PasswordInput.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';

import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import patient from "@/classes/UserData";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePassword',
  setup(__props) {

const router = useRouter();

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref(null)
const errors      = ref([])
const showSuccess = ref(false)
const showConfirmation = ref(false)

const patientData = computed(() => patient.getCurrentUser())
const payload = ref({
    patient_id: patientData.value.patient_id,
    current_password: null,
    password: null,
    password_confirmation: null,
})

const updatePassword = () => {
    loader.value = true;

    patient.updatePassword(payload.value)
        .then((result: any) => {
            loader.value = false;
            if(result.data.data[0].status == 'success') {
                showSuccess.value = true;

                payload.value = {}

                setTimeout(() => {
                    window.location.replace('/account-details')
                }, 1000)
            }
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PortalLayout, { defaultTitle: false }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(PasswordInput, {
              id: "current-password",
              placeholder: "Current Password",
              modelValue: payload.value.current_password,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.current_password) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(PasswordInput, {
              id: "new-password",
              placeholder: "New Password",
              helper: "",
              modelValue: payload.value.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.password) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(PasswordInput, {
              id: "confirm-new-password",
              placeholder: "Confirm New Password",
              modelValue: payload.value.password_confirmation,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.password_confirmation) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(ButtonComponent, {
              disabled: loader.value,
              text: "Save Changes",
              type: 'submit',
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showConfirmation.value = true))
            }, null, 8, ["disabled"])
          ])
        ])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[4] || (_cache[4] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[6] || (_cache[6] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[7] || (_cache[7] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Confirm",
        title: "Password Submitted!",
        content: "Password has been updated successfully",
        "no-btn": ""
      }, null, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[8] || (_cache[8] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[9] || (_cache[9] = ($event: any) => {showConfirmation.value = false; updatePassword() }),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Submit Changes?",
        content: "Are you sure you wish to update this password?"
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})